import gameConfig from '../../assets/config';

import UbuntuBold from '../../assets/fonts/ubuntu/UBUNTU-B.TTF';
import UbuntuRegular from '../../assets/fonts/ubuntu/UBUNTU-R.TTF';
import BloggerSansBold from '../../assets/fonts/blogger/blogger-sans-bold.ttf';
import { getAssetsScale } from 'Engine/utils/getAssetsScale';
import { soundsPreloaderConfig } from '../enums/eSounds';
import gameSizeConfig from '../configs/gameSizeConfig';
import eAnimations from '../animations/animationTypes';

import flashlib from '../../assets/exported/gameMobile/FlashLib.json';

const availableScales = ['0.7','0.75','0.8','0.9'];
const scale = getAssetsScale({
  availableScales,
  safeWidthPortrait: gameSizeConfig.SAFE_WIDTH_PORTRAIT,
  safeHeightPortrait: gameSizeConfig.SAFE_HEIGHT_PORTRAIT,
  safeWidthLandscape: gameSizeConfig.SAFE_WIDTH_LANDSCAPE,
  safeHeightLandscape: gameSizeConfig.SAFE_HEIGHT_LANDSCAPE,
})

// import assets from '../../assets/exported/gameMobile/FlashLibAssets';
const assets = `flashlib/gameMobile/AssetsCombined@${scale}x.json`;

export default {
  assets: [
    {name: 'GameAssets', path: assets, extension: 'json'},
    {name: 'GameFlashLib', path: flashlib, extension: 'json'},
    {name: 'gameConfig', path: gameConfig, extension: 'json'},
    {name: eAnimations.SYMBOLS, path: 'animations/symbols/symbols_happy_cookie_pro.json', extension: 'json'},
    {name: eAnimations.BACKGROUND, path: 'animations/background/bg_hc.json', extension: 'json'},
    // {name: 'coins', path: 'animations/coins/skeleton.json', extension: 'json'},
    {name: eAnimations.COOKIE, path: 'animations/cookie/pers_cookie.json', extension: 'json'},
    {name: eAnimations.JACKPOT_PANEL, path: 'animations/sweep_dwb/skeleton.json', extension: 'json'},
    {name: 'BMFont', path: 'fonts/BMFont/BMFont.xml', extension: 'xml'},
  ],
  delayedAssets: [
    {name: eAnimations.ANTISIPATOR, path: 'animations/antisipator/antisipator_cookie.json', extension: 'json'},
    {name: eAnimations.BIG_WIN, path: 'animations/bigWins/DWB_b_o_e.json', extension: 'json'},
  ],
  fonts: [
    { name: 'UbuntuBold',
      path: UbuntuBold,
    },
    {
      name: 'UbuntuRegular',
      path: UbuntuRegular,
    },
    {
      name: 'BloggerSansBold',
      path: BloggerSansBold,
    },
  ],
  sounds: soundsPreloaderConfig
}
